import axios from 'axios'
import { apiPath } from '@/helpers/api.js'
import qs from 'qs'
import { unauthorizedInterceptor } from './helpers/api'

const api = axios.create({
  baseURL: apiPath,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
  json: true,
  headers: {
    common: {
      Authorization: localStorage.AuthToken
    }
  }
})

api.interceptors.response.use( 
  response => response,
  unauthorizedInterceptor
)

export { api }
